import { useState } from 'react';

const mockPosts = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=custom%20printed%20phone%20case%20with%20vibrant%20colorful%20design%20held%20by%20young%20person%20selfie%20style%2C%20street%20fashion%2C%20trendy%20aesthetic%2C%20warm%20tones%2C%20instagram%20style%20product%20photo&width=600&height=600&seq=ig101&orientation=squarish',
    type: 'reel',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=iPhone%20case%20store%20display%20with%20rows%20of%20colorful%20phone%20cases%20beautifully%20arranged%2C%20warm%20retail%20lighting%2C%20premium%20product%20showcase%2C%20modern%20minimal%20aesthetic&width=600&height=600&seq=ig102&orientation=squarish',
    type: 'photo',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20premium%20custom%20phone%20case%20printing%20process%2C%20vibrant%20colors%20fresh%20print%2C%20behind%20the%20scenes%20production%2C%20product%20manufacturing%20quality&width=600&height=600&seq=ig103&orientation=squarish',
    type: 'reel',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=flat%20lay%20of%20multiple%20colorful%20iPhone%20cases%20arranged%20artistically%20on%20dark%20surface%2C%20aesthetic%20product%20photography%2C%20trendy%20mobile%20accessories%20display%2C%20clean%20shadows&width=600&height=600&seq=ig104&orientation=squarish',
    type: 'photo',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=young%20person%20holding%20custom%20printed%20phone%20case%20smiling%2C%20street%20style%20look%2C%20personalized%20phone%20case%20gift%20reveal%2C%20happy%20customer%2C%20warm%20candid%20photography&width=600&height=600&seq=ig105&orientation=squarish',
    type: 'photo',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=premium%20iPhone%20cases%20collection%20featuring%20transparent%20matte%20black%20and%20colorful%20designs%2C%20modern%20product%20flat%20lay%2C%20clean%20minimal%20photography%2C%20retail%20display%20quality&width=600&height=600&seq=ig106&orientation=squarish',
    type: 'reel',
  },
];

const INSTAGRAM_URL = 'https://www.instagram.com/nusretbulut01/';

export default function SocialMedia() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="instagram" className="py-20 md:py-28 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-instagram-line text-white/40 text-base" />
              </div>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/40 text-xs font-bold uppercase tracking-[0.3em] hover:text-white/70 transition-colors cursor-pointer"
              >
                @nusretbulut01
              </a>
            </div>
            <h2
              className="text-white uppercase leading-none"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.2rem, 6vw, 4.5rem)' }}
            >
              Bizi Böyle
              <br />
              <span className="text-[#FF4500]">Tanıyorlar</span>
            </h2>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 bg-gradient-to-r from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] text-white px-6 py-3 rounded-full text-sm font-bold transition-all hover:opacity-90 whitespace-nowrap cursor-pointer shrink-0"
          >
            <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
            @nusretbulut01
          </a>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3">
          {mockPosts.map((post) => (
            <a
              key={post.id}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-xl aspect-square block cursor-pointer"
              onMouseEnter={() => setHovered(post.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <img
                src={post.image}
                alt={`Instagram @nusretbulut01 post ${post.id}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/55 transition-all duration-300" />

              {/* Reel badge */}
              {post.type === 'reel' && (
                <div className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-white text-xl drop-shadow-lg" />
                </div>
              )}

              {/* Hover overlay */}
              <div className={`absolute inset-0 flex flex-col items-center justify-center gap-2 transition-opacity duration-300 ${hovered === post.id ? 'opacity-100' : 'opacity-0'}`}>
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-external-link-line text-white text-sm" />
                </div>
                <span className="text-white text-xs font-semibold">Instagram'da Gör</span>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 p-5 bg-white/[0.03] border border-white/8 rounded-2xl">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] rounded-xl">
              <i className="ri-instagram-line text-white text-lg" />
            </div>
            <div>
              <p className="text-white font-bold text-sm">@nusretbulut01</p>
              <p className="text-white/40 text-xs">Güncel içerikler için takip et</p>
            </div>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-white text-black px-5 py-2.5 rounded-full text-sm font-bold hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
            Tüm Gönderileri Gör
          </a>
        </div>
      </div>
    </section>
  );
}
